const sourceWidths = {
  '/images/owner-projects/brick-steps-finished.webp': 1024,
  '/images/owner-projects/chimney-blue-sky.webp': 768,
  '/images/owner-projects/concrete-driveway-slab.webp': 603,
  '/images/owner-projects/concrete-long-sidewalk.webp': 603,
  '/images/owner-projects/concrete-patio-base-prep.webp': 1024,
  '/images/owner-projects/concrete-patio-finished.webp': 1024,
  '/images/owner-projects/culvert-headwall.webp': 1024,
  '/images/owner-projects/door-opening-before.webp': 768,
  '/images/owner-projects/door-opening-demolition.webp': 603,
  '/images/owner-projects/door-opening-finished.webp': 562,
  '/images/owner-projects/door-opening-lintel.webp': 562,
  '/images/owner-projects/faux-stone-new-construction.webp': 603,
  '/images/owner-projects/landscape-retaining-border.webp': 1152,
  '/images/owner-projects/multicolor-paver-walkway.webp': 1000,
  '/images/owner-projects/new-construction-house-chimney.webp': 1024,
  '/images/owner-projects/paver-driveway-finished.webp': 603,
  '/images/owner-projects/paver-patio-finished.webp': 603,
  '/images/owner-projects/tile-backsplash-finished.webp': 1152,
  '/images/owner-projects/vic-owner-portrait.webp': 1152,
  '/images/owner-projects/vic-with-work-truck.webp': 1024,
};

function variant(src, width) {
  return src.replace(/\.webp$/, `-${width}.webp`);
}

export function ResponsiveImage({ src, sizes = '(max-width: 767px) calc(100vw - 24px), (max-width: 1023px) calc(100vw - 32px), 50vw', ...props }) {
  const sourceWidth = sourceWidths[src];
  if (!sourceWidth) return <img src={src} {...props} />;

  const candidates = [480, 640, 768, 1200]
    .filter((width) => width < sourceWidth)
    .map((width) => `${variant(src, width)} ${width}w`);
  candidates.push(`${src} ${sourceWidth}w`);

  return <img src={src} srcSet={candidates.join(', ')} sizes={sizes} {...props} />;
}
